import { Info, AlertTriangle, CheckCircle2, XCircle } from "lucide-react";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import type { SectionComponentProps } from "./registry";

type CalloutData = {
  type?: string;
  variant?: string;
  title?: string;
  content: string;
};

const VARIANT_MAP: Record<string, { icon: typeof Info; className: string }> = {
  info: {
    icon: Info,
    className: "border-blue-500/30 bg-blue-500/5 [&>svg]:text-blue-500",
  },
  warning: {
    icon: AlertTriangle,
    className: "border-amber-500/30 bg-amber-500/5 [&>svg]:text-amber-500",
  },
  success: {
    icon: CheckCircle2,
    className: "border-emerald-500/30 bg-emerald-500/5 [&>svg]:text-emerald-500",
  },
  error: {
    icon: XCircle,
    className: "border-red-500/30 bg-red-500/5 [&>svg]:text-red-500",
  },
  destructive: {
    icon: XCircle,
    className: "border-red-500/30 bg-red-500/5 [&>svg]:text-red-500",
  },
};

export function CalloutSection({ data }: SectionComponentProps) {
  const callout = data as CalloutData;
  if (!callout?.content) return null;

  const variant = callout.variant || callout.type || "info";
  const config = VARIANT_MAP[variant] ?? VARIANT_MAP.info;
  const Icon = config.icon;

  return (
    <Alert className={config.className}>
      <Icon />
      {callout.title && <AlertTitle>{callout.title}</AlertTitle>}
      <AlertDescription>{callout.content}</AlertDescription>
    </Alert>
  );
}
